import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { TableCellDiv } from 'src/core/ui/TableCellDiv';
import { TableShimmeringDiv } from 'src/tables/Table/Table.styled';
import { formatCurrency } from 'src/utils/numberFormatter';
import { RetailClient } from 'src/WebApiController';

interface BuyerCreditCellProps {
  email: string;
}

export function BuyerCreditCell({ email }: BuyerCreditCellProps) {
  const { activeAccountWebClientConfig } = useAppContext();

  const { data, isLoading } = useQuery({
    queryKey: ['buyerCredit', email],
    queryFn: async () => {
      const client = new RetailClient(activeAccountWebClientConfig);
      return client.getBuyerCredit(email);
    },
    enabled: !!email,
  });

  if (isLoading) {
    return <TableShimmeringDiv />;
  }

  if (!data) {
    return <TableCellDiv align="left">—</TableCellDiv>;
  }

  return (
    <TableCellDiv align="left">
      {formatCurrency(data.balance, data.currencyCode, 2)}
    </TableCellDiv>
  );
}
